import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { ID } from "src/libs/interfaces/layouts"
import usePosition, { IPositionHook } from "src/modules/pe-landing-module/hooks/usePosition"
import usePrimitiveData from "src/modules/pe-landing-module/hooks/usePrimitiveData"
import { ILandingFloat, ILandingPrimitive, ILandingSection, IScreenPosition } from "../../../data/interfaces"
import { PrimitiveContainer, PrimitiveContent } from "../primitive"

/* Protopia Ecosystem component */
export interface IPrimitiveProps {
    float?: ILandingFloat
    primitive?: ILandingPrimitive
    animated?: ANIMATED_STYLE 
    animated_delay? : ANIMATE_DELAY
    section?: ILandingSection
    i?:number
    data?: any
    onClick?: () => void
    field?: string
    ["data-content-id"]?: ID
} 
const Primitive = ({ ...props }: IPrimitiveProps): JSX.Element => {
    const primitive = usePrimitiveData(props.primitive)  
    const animated_delay = props.animated_delay === ANIMATE_DELAY.WATERFALL ? (props.i || 0) % 6 : props.animated_delay
    return <PrimitiveContainer primitive={primitive} i={props.i || 0} animated={ props.animated } animated_delay={ animated_delay }>
        <PrimitivePositionContainer {...props} >
            <PrimitiveContent 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            />
        </PrimitivePositionContainer>
    </PrimitiveContainer>
}
export default Primitive

export interface IPrimitiveContainerProps extends IPrimitiveProps {
    children: JSX.Element
}
const PrimitivePositionContainer = ({ ...props }: IPrimitiveContainerProps): JSX.Element => {  
    const position: IPositionHook = usePosition( props.primitive! )
    const pos: IScreenPosition =  position.position
    const transform = `translateX(${pos.left || 0}px) translateY(${pos.top || 0}px) rotate(${pos.rotate || 0}deg)`
    return <div className="landing-primitive-position-container" style={{ transform }} >
        { props.children }
    </div>
}